import {
  useCompleteLvdProductComplianceFile,
  useUncompleteLvdProductComplianceFile,
  type LvdProductComplianceFileView,
} from '@/shared/hooks/api/lvdComplianceFiles'
import { ProductComplianceFileSignOffActions } from '@/v2/components/product-compliance-briefing/ProductComplianceFileSignOffActions'
import { hasConfirmedLvdStandardsForSignOff } from '@/v2/lib/lvdProductComplianceFileDeclarationOfConformityRequirements'

export function LvdProductComplianceFileSignOffActions({
  productId,
  productFile,
}: {
  productId: string
  productFile: LvdProductComplianceFileView
}) {
  const { mutateAsync: completeFile, isPending: isCompleting } =
    useCompleteLvdProductComplianceFile(productId)
  const { mutateAsync: uncompleteFile, isPending: isUncompleting } =
    useUncompleteLvdProductComplianceFile(productId)

  return (
    <ProductComplianceFileSignOffActions
      productFile={productFile}
      canComplete={hasConfirmedLvdStandardsForSignOff(productFile)}
      isPending={isCompleting || isUncompleting}
      i18nKeyPrefix='v2.pages.products.detail.lvdFiles'
      onComplete={completeFile}
      onUncomplete={uncompleteFile}
    />
  )
}
